export const SignatureProfileExperienceCta = ({
  profile,
}: {
  profile: any;
}) => {
  const artistFullName = [profile?.artistFirstName, profile?.artistLastName]
    .filter(Boolean)
    .join(" ");

  const hasName = Boolean(artistFullName && artistFullName.trim().length > 0);
  const lead = profile?.experienceLeadContent;
  const links = Array.isArray(profile?.experienceLinks)
    ? profile.experienceLinks
    : [];

  const showSection = Boolean(hasName || lead || links.length > 0);

  if (!showSection) return null;

  return (
    <section className="relative py-20 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url("/lovable-uploads/890365c9-1a93-4aca-bee8-5e65bb2d5140.png")',
          filter: "blur(8px)",
          transform: "scale(1.1)",
        }}
      />
      <div className="absolute inset-0 bg-black bg-opacity-60" />
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center text-white">
          {hasName ? (
            <h2 className="font-playfair text-4xl md:text-5xl font-bold mb-6">
              {/* 28. Signature profile first name and last name */}
              {`Experience ${artistFullName}'s Art`}
            </h2>
          ) : null}
          {lead ? (
            <p className="text-lg mb-8 text-gray-200">
              {/* 29. Signature profile experience_lead_content */}
              {lead}
            </p>
          ) : null}
          {links.length > 0 ? (
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              {/* 30. Signature profile experience_links */}
              {links.map((item: any) => (
                <a
                  key={item?.id || item?.title}
                  href={item?.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-11 px-8 rounded-full border-white text-gray-50 bg-violet-600 hover:bg-violet-500"
                >
                  {item?.title || "Visit"}
                </a>
              ))}
            </div>
          ) : null}
          {/* TODO SIGNATURE PROFILE SUBSCRIBE https://artstorefronts.atlassian.net/browse/ART-8157 */}
          {/* <div className="mt-12 max-w-md mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-full p-1">
              <form className="flex" style={{ margin: "0px" }}>
                <input
                  type="email"
                  placeholder="Enter your email for updates"
                  className="flex-grow px-4 py-3 bg-transparent text-white placeholder-gray-300 focus:outline-none"
                />
                <button
                  type="button"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-10 px-4 py-2 rounded-full bg-white text-black hover:bg-gray-100"
                  style={{
                    marginTop: "4px",
                    marginRight: "4px",
                  }}
                >
                  Subscribe
                </button>
              </form>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default SignatureProfileExperienceCta;
